import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchTabUsers } from "services/signontab.service";
import { TabUserEntity } from "types/Signontab";

interface TabUserContainerState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: TabUserEntity[];
}

const initialState: TabUserContainerState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
};

const tabUserContainerSlice = createSlice({
  name: "user-tab",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(state: TabUserContainerState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(
      state: TabUserContainerState,
      action: PayloadAction<{ error: string }>
    ) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state: TabUserContainerState, action: PayloadAction<any>) {
      state.collection = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
  },
});

const { actions, reducer } = tabUserContainerSlice;

export const { setDestroy, setLoading, setError, setData } = actions;
export default reducer;

// Only the newest request may change the state: after a company switch or a reload,
// an older answer would show the wrong list or an error that no longer applies.
let latestRequest = 0;

export const fetchTabUsersList =
  (companyId: string) => async (dispatch: any) => {
    latestRequest += 1;
    const request = latestRequest;
    dispatch(setLoading(true));
    try {
      const data = await fetchTabUsers(companyId);
      if (request === latestRequest) dispatch(setData(data));
    } catch (e) {
      const error = "not_fetch";
      if (request === latestRequest) dispatch(setError({ error }));
    }
  };
